import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import Toast from "../../Dialogs/toast/Toast";

// Styles
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";

export class Cuvette extends React.Component {
  constructor(props){
    super(props)

    this.state = {controlsVisible: false};

    const interactions = (heldObj, target) => {
      //Don't run if this cuvette not the held object
      if(heldObj.type !== "Cuvette" || heldObj.id !== this.props.id){
        return null;
      }
      if (target === undefined || target === null) {
        return null;
      }
      //All Spectrophotometer interactions
      if (target.type !== "Spectrophotometer") {
        return null;
      }

      //Get the targeted Spectrophotometer
      const tubeID = target.id
      const targetSpectrophotometer = this.props.interactionProps.spectrophotometers[tubeID - 1]

      if(!targetSpectrophotometer.lidOpen) {
        this.makeToast("WARNING", "You must first open the spectrophotometer before inserting a cuvette.", "Spectrophotometer is closed!");
        return null;
      }

      if(this.props.lidId < 0){
        this.makeToast("WARNING", "You must place a lid on the cuvette before inserting into the spectrophotometer.", "Cuvette open!");
        return null;
      }

      if(targetSpectrophotometer.cuvetteId >= 0){
        this.makeToast("WARNING", "The spectrophotometer already has a cuvette inside it.", "Spectrophotometer is full!");
        return null;
      }

      this.props.onDropCuvette({
        cuvetteId: this.props.id,
        id: targetSpectrophotometer.id,
        type: "Cuvette",
        solution: this.props.solution
      })

      this.props.setCuvettesInScene({
        id: this.props.id,
        inScene: false
      });

      // Reset the tube position to a zero transform
      heldObj.htmlObj.style.transform = "translate3d(0px,0px,0px) rotateZ(0deg)"
      
    }
    Object.defineProperty(interactions, 'name', {value: ('cuvette_interactions_'+this.props.id), configurable: true});
    this.props.pushInteractions([interactions])
  }



  componentWillMount() {
    this.props.createCuvette({
      props: this.props.defaultProps,
    });
  }
  cuvetteSelected = (e) => {

    this.props.setCuvetteHeld({
      id: this.props.id,
      held: true,
    })
    this.props.setHeldObject({
      id: this.props.id,
      type: "Cuvette",
      htmlObj: e.target,
    });
    if(!this.props.controlsVisible){
      this.showControls()
  }
  }

  cuvetteUnselected = (e) => {
    this.props.setCuvetteHeld({
      id: this.props.id,
      held: false,
    })
  }

  showControls = ()=> {
    this.props.hideAllControls();
    this.props.setCuvetteControlVisibility({id: this.props.id, controlsVisible: true});
  }

  makeToast = (type, msg, title) => {
    let color = "";
    if (type === "HINT") {
      color = colors.yellow1;
    } else {
      color = colors.red1;
    }

    toast(<Toast type={type} msg={msg} title={title} />, {
      className: css({
        border: "2px solid " + color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px"
      }),
      progressClassName: css({
        background: color
      }),
      position: "top-center",
      autoClose: 5000
    });
  };

  render() {
    return (
      <ul style={{
        visibility: !this.props.inScene ? "hidden" : null,
        zIndex: this.props.controlsVisible || this.state.controlsVisible ? 99 : null,
        padding: 0,
        margin: 0
      }}>
        <li
          id={"Cuvette_"+this.props.id}
          className={'Cuvette draggable dropTarget'}
          onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.cuvetteSelected() } }
          onDragStart={(e) => this.cuvetteSelected(e)}
          onDragEnd={(e) => this.cuvetteUnselected(e)}
          onMouseEnter={(e)=>this.setState({controlsVisible: true})}
          onMouseLeave={(e)=>this.setState({controlsVisible: false})}
          draggable
          tabIndex={0}
          style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)"}}>
          <p aria-hidden="true" className="label">{this.props.tooltipLabel}</p>
          <Graphics id={this.props.id} />
        </li>
      </ul>
    );
  }
}

Cuvette.propTypes = {
  createCuvette: PropTypes.func,
};

Cuvette.defaultProps = {};
